import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class WattFlowMeter extends PureComponent {
    static propTypes = {
        color: PropTypes.string,
        secondaryColor: PropTypes.string,
        size: PropTypes.number
    };

    static defaultProps = {
        color: '#8e8e8e',
        secondaryColor: '#fff',
        size: 50
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.25).toString()} width={(size / 1.25).toString()} viewBox="0 0 300 251.79">
                <rect y={66.18} width={300} height={75.13} rx={2.83} ry={2.83} fill={color} />
                <circle cx={150} cy={103.75} r={100.62} fill={color} />
                <path
                    d="M150 207.5a103.75 103.75 0 1 1 103.75-103.75A103.87 103.87 0 0 1 150 207.5zm0-201.23a97.49 97.49 0 1 0 97.49 97.49A97.6 97.6 0 0 0 150 6.27z"
                    fill={secondaryColor}
                />
                <path d="M193.33 72.45h-86.66a6.265 6.265 0 0 1 0-12.53h86.65a6.265 6.265 0 1 1 0 12.53z" fill={secondaryColor} />
                <path
                    d="M238.22 139.22c-2.76-4.06-5.19-7.79-7.47-11.2a4.94 4.94 0 0 0-1.3-1.3 4.23 4.23 0 0 0-5.84 1.3c-2.11 3.41-4.54 7-7.47 11.2-12.82 18.83-32 47.23-32 63.46a42.82 42.82 0 0 0 12.66 30.35 43.36 43.36 0 0 0 30.35 12.5 43.22 43.22 0 0 0 43-43c.05-16.24-19.15-44.48-31.93-63.31zm14.55 79.2a28.85 28.85 0 0 1-10.7 10.36 4.9 4.9 0 0 1-2.46.66 5 5 0 0 1-1.3-.17 5.43 5.43 0 0 1-3.3-2.61 4.83 4.83 0 0 1-.43-3.84 5.29 5.29 0 0 1 2.37-3.05 18.91 18.91 0 0 0 7.15-6.83 20 20 0 0 0 3-9.48 5.13 5.13 0 0 1 1.7-3.49 4.8 4.8 0 0 1 3.64-1.26 5.11 5.11 0 0 1 3.46 1.69 4.89 4.89 0 0 1 1.26 3.64 28.36 28.36 0 0 1-4.39 14.38z"
                    fill={color}
                />
                <path
                    d="M227.23 126.05a4 4 0 0 1 2.23.68 4.94 4.94 0 0 1 1.3 1.3c2.27 3.41 4.71 7.14 7.47 11.2 12.82 18.83 32 47.07 32 63.3a43.22 43.22 0 0 1-43 43 43.36 43.36 0 0 1-30.35-12.5 42.82 42.82 0 0 1-12.66-30.35c0-16.23 19.15-44.63 32-63.46 2.92-4.22 5.36-7.79 7.47-11.2a4.38 4.38 0 0 1 3.62-2m12.38 103.39a4.9 4.9 0 0 0 2.46-.66 28.85 28.85 0 0 0 10.7-10.36 28.36 28.36 0 0 0 4.36-14.38 4.89 4.89 0 0 0-1.26-3.64 5.11 5.11 0 0 0-3.46-1.69h-.4a4.83 4.83 0 0 0-3.24 1.28 5.13 5.13 0 0 0-1.7 3.49 20 20 0 0 1-3 9.48 18.91 18.91 0 0 1-7.15 6.83 5.29 5.29 0 0 0-2.37 3.05 4.83 4.83 0 0 0 .43 3.84 5.43 5.43 0 0 0 3.3 2.61 5 5 0 0 0 1.3.17m-12.43-109.64a10.61 10.61 0 0 0-8.83 4.76l-.06.09-.06.09c-1.95 3.15-4.23 6.52-7.29 10.93-16.76 24.6-33.09 50-33.09 67a48.91 48.91 0 0 0 14.49 34.78 49.47 49.47 0 0 0 34.78 14.33 49.49 49.49 0 0 0 49.27-49.27c0-16.88-15.64-41.24-33.06-66.82-1.85-2.72-3.55-5.3-5.16-7.73l-2.22-3.4a11.2 11.2 0 0 0-3-3 10.25 10.25 0 0 0-5.7-1.73z"
                    fill={secondaryColor}
                />
            </svg>
        );
    }
}

export default withTheme(WattFlowMeter);



// WEBPACK FOOTER //
// ./data/common/iconsvg/WaterFlowMeter.js